import { useNavigate } from "react-router-dom"
import useTargetStorage from "@/hooks/useTargetStorage"
import { useTranslation } from "react-i18next"
import CreateProductForm from "features/storages/products/createProductForm"
import Callout from "components/callout/callout"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import PageTitle from "features/navigation/pageTitle"
import useStorages from "@/hooks/useStorages"
import { paramGuardStorage } from "@/utils/paramGuard"
import RightSidebar from "@/components/sidebar/right/RightSidebar"

const CreateProductPage = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()

    const { targetStorageDocId: storageId } = useTargetStorage()
    
    const { 
        storage,
        storageStatus 
    } = useStorages({ storageId })

    // Check params and declare safe ones to use in JSX
    if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
        return <></>
    }
    const safeStorageId = storageId!;

    // Return the JSX.
    return (
        <>
            <PageTitle title={t('titleCreateProduct')} />
            <CreateProductForm storageId={safeStorageId} />
            <RightSidebar storageId={safeStorageId} />
        </>
    )
}

export default CreateProductPage